module.exports = __webpack_public_path__ + "img/bmBg.23980354.jpg";